import { render, staticRenderFns } from "./UnlinkClinic.vue?vue&type=template&id=3c118984&scoped=true"
import script from "./UnlinkClinic.vue?vue&type=script&lang=js"
export * from "./UnlinkClinic.vue?vue&type=script&lang=js"
import style0 from "./UnlinkClinic.vue?vue&type=style&index=0&id=3c118984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c118984",
  null
  
)

export default component.exports